import { useSyncExternalStore } from 'react'
import { getScreenSize } from './getScreenSize'
import { subscribeToWindowSize } from './subscribeToWindowSize'

const getSnapshot = () => getScreenSize().isWideScreen

export const useIsWideScreen = () => useSyncExternalStore(subscribeToWindowSize, getSnapshot)
